
  document.addEventListener('DOMContentLoaded', function () {
    const timeline = document.querySelector('.header_timeline_1');

    if (!timeline) return; // Safe check in case it doesn't exist on this page

    window.addEventListener('scroll', function () {
      const rect = timeline.getBoundingClientRect();
      if (rect.top <= 70) {
        timeline.classList.add('active');
      } else {
        timeline.classList.remove('active');
      }
    });
  });
function comparemblslider(){
jQuery('.select_card-1 .owl-carousel').owlCarousel({
  loop: true,
  margin: 15,
  nav: false,
  dots: true,
  slidesToShow: 4.5,
  dotsEach:true,
  autoplayTimeout: 3000, // duration after slide move
  autoplay: true,
  autoplaySpeed: 1000,
  fluidSpeed: true,
  responsive: {
    0: {
      items: 1.1,
    },
    375: {
      items: 1.2,
    },
    576: {
      items: 2.1,
    },
    768: {
      items: 2.2,
    },
    992: {
      items: 3.5,
    },
    1200: {
      items: 4.5
    }
  }
});
  }
comparemblslider();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
   comparemblslider();
  });

  document.addEventListener('shopify:section:select', function(event) {
    comparemblslider();
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    comparemblslider();
  });

  document.addEventListener('shopify:section:unload', function(event) {
    comparemblslider();
  });

  document.addEventListener('shopify:block:select', function(event) {
   comparemblslider();
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    comparemblslider();
  });

  document.addEventListener('shopify:section:reorder', function(event) {
   comparemblslider();
  });

  document.addEventListener('shopify:section:load', function(event) {
   comparemblslider();
  });

  document.addEventListener('shopify:section:save', function(event) {
    comparemblslider();
  });
}




// home 2

  document.addEventListener('DOMContentLoaded', function () {
    const radios = document.querySelectorAll('input[name="purchase1"]');
    const selectBox = document.getElementById('subscribeSelect');
if(document.querySelectorAll('input[name="purchase1"]').length > 0){
    radios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === 'subscribe') {
          selectBox.style.display = 'block';
        } else {
          selectBox.style.display = 'none';
        }
      });
    });
}

  });


    document.addEventListener('DOMContentLoaded', function () {
    const radios2 = document.querySelectorAll('input[name="purchase2"]');
    const selectBox2 = document.getElementById('subscribeSelect2');
if(document.querySelectorAll('input[name="purchase2"]').length > 0){
    radios2.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === 'subscribe2') {
          selectBox2.style.display = 'block';
        } else {
          selectBox2.style.display = 'none';
        }
      });
    });
  }
  });


      document.addEventListener('DOMContentLoaded', function () {
    const radios3 = document.querySelectorAll('input[name="purchase3"]');
    const selectBox3 = document.getElementById('subscribeSelect3');
if(document.querySelectorAll('input[name="purchase3"]').length > 0){
    radios3.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === 'subscribe3') {
          selectBox3.style.display = 'block';
        } else {
          selectBox3.style.display = 'none';
        }
      });
    });
  }
  });


      

// slider 1
jQuery('.select_card-2 .owl-carousel').owlCarousel({
  loop: true,
  margin: 15,
  nav: false,
  dots: false,
  slidesToShow: 4.5,
  dotsEach:false,
  autoplayTimeout: 2500, // duration after slide move
  autoplay: true,
      autoplaySpeed: 1500,
  fluidSpeed: true,
  center:true,
  responsive: {
    0: {
       center:false,
      items: 1.2,
    },
    375: {
           center:false,
      items: 1.4,
    },
    576: {
       center:true,
      items: 2.5,
    },
    768: {
            center:true,
      items: 2.7,
    },
    992: {
      items: 3.5,
    },
    1200: {
      items: 4.5
    }
  }
});


// hi_fidelity page slider

const nextIcon1 = '<img src="https://cdn.shopify.com/s/files/1/0563/3913/6579/files/golden-arrow-left.svg?v=1760811795" alt="Previous">';
const prevIcon1 = '<img src="https://cdn.shopify.com/s/files/1/0563/3913/6579/files/golden-arrow-right.svg?v=1760811795" alt="Next">';
jQuery('.select_card-3 .owl-carousel').owlCarousel({
  loop: false,
  margin: 15,
  nav: true,
  dots: false,
  navText: [nextIcon1, prevIcon1],
  slidesToShow: 4,
  smartSpeed: 1500,
  dotsEach:false,
  autoplayTimeout: 4500, // duration after slide move
  autoplay: true,
  autoplaySpeed: 1500,
  fluidSpeed: true,
  center:false,
  responsive: {
    0: {
      items: 1,
    },
    375: {
      items: 1,
    },
    576: {
      items: 2,
    },
    768: {
      items: 2,
    },
    992: {
      items: 3,
    },
    1200: {
      items: 4
    }
  }
});


  
  // =========== video section =========== 

const video = document.getElementById("player_videoId");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}
if(document.getElementById("circle-play-b") != null){
circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
	circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
	circlePlayButton.style.opacity = 1;
});
}


  

